import { render, staticRenderFns } from "./InternsOptionsFormPage.vue?vue&type=template&id=0dab70e7&"
import script from "./InternsOptionsFormPage.vue?vue&type=script&lang=js&"
export * from "./InternsOptionsFormPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports